<template lang="pug">
div.preview-element.nse-frame(:style="wrapStyle" v-if="showFrame")
</template>

<script>
import {computed} from "vue";
import ParseSpecifications from "@/commons/ParseSpecifications";

export default {
	name: "FramePhysicalPreview",
	props: {

		selectedItems: {
			type: Object,
			default() {
				return {}
			}
		},

		dimensions: {
			type: Object,
			default() {
				return {}
			}
		}
	},

	setup(props) {
		const spec = computed(() => {
			return ParseSpecifications.parse(props.selectedItems.poster_size, props.dimensions)
		});

		const bgFrame = computed(() =>{
			var bgFrame = '';
			if (props.selectedItems.poster_frame) {
				var frame = props.selectedItems.poster_frame.value;
				if (frame != 'none') {
					bgFrame = props.selectedItems.poster_size.frames[frame].image;
				}
			}
			return bgFrame;
		})

		const wrapStyle = computed(() => {
		    var css = "";
            if (bgFrame.value) {
                css = `
                box-shadow: 1px 1px 7px rgb(0 0 0 / 18%);
                background-image: url(${bgFrame.value});
                `;
            }
			return `
				width: ${spec.value.frame.width}%;
				height: ${spec.value.frame.height}%;
				${css}`;
		});

		const showFrame = computed(() => {
            return props.selectedItems.product_finish.value === 'poster';
        })

		return {
			spec,
			wrapStyle,
			bgFrame,
            showFrame
		}
	}
}
</script>

<style lang="scss">
.preview-element {
	&.nse-frame {
		top: 50%;
		left: 50%;
		transform: translateY(-50%)  translateX(-50%);
		background-image: var(--frame-background);
		background-size: 100% 100%;
		background-repeat: no-repeat;
		z-index: 3;
	}
}
</style>
